import React from 'react';

// Color presets for the KeyData notification banners. Each tone keeps the exact
// palette the inline banners used before this was extracted.
const TONES = {
  amber:   { bg: '#fffbeb', border: '#f59e0b', text: '#78350f', subtitle: '#92400e', accent: '#f59e0b', shadow: '245,158,11' },
  orange:  { bg: '#fff7ed', border: '#f59e0b', text: '#7c2d12', subtitle: '#b45309', accent: '#f59e0b', shadow: '245,158,11' },
  redDark: { bg: '#fef2f2', border: '#dc2626', text: '#7f1d1d', subtitle: '#991b1b', accent: '#dc2626', shadow: '220,38,38' },
  red:     { bg: '#fef2f2', border: '#ef4444', text: '#7f1d1d', subtitle: '#b91c1c', accent: '#ef4444', shadow: '239,68,68' },
  green:   { bg: '#ecfdf5', border: '#10b981', text: '#065f46', subtitle: '#047857', accent: '#10b981', shadow: '16,185,129' },
  blue:    { bg: '#eff6ff', border: '#3b82f6', text: '#1e3a8a', subtitle: '#1d4ed8', accent: '#3b82f6', shadow: '59,130,246' },
  // The unclaimed case-ticket and unclaimed Mercari-admin banners, which were
  // still inline on tama-develop-2 when this component arrived from main.
  violet:  { bg: '#f5f3ff', border: '#8b5cf6', text: '#4c1d95', subtitle: '#6d28d9', accent: '#8b5cf6', shadow: '139,92,246' },
  indigo:  { bg: '#eef2ff', border: '#6366f1', text: '#312e81', subtitle: '#4338ca', accent: '#6366f1', shadow: '99,102,241' },
  purple:  { bg: '#f5f3ff', border: '#7c3aed', text: '#3b0764', subtitle: '#5b21b6', accent: '#7c3aed', shadow: '124,58,237' },
};

// A dismissible-looking notification banner: count badge + title/subtitle + CTA.
// Renders nothing when count is 0 so call sites don't need their own guard.
const ClaimBanner = ({ count, tone = 'blue', title, subtitle, cta, onClick }) => {
  if (!count) return null;
  const t = TONES[tone] || TONES.blue;

  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        background: t.bg,
        border: `1.5px solid ${t.border}`,
        color: t.text,
        padding: '12px 18px',
        borderRadius: '10px',
        marginBottom: '16px',
        cursor: 'pointer',
        boxShadow: `0 2px 10px rgba(${t.shadow},0.2)`,
        userSelect: 'none',
      }}
    >
      <span style={{
        background: t.accent,
        color: '#fff',
        borderRadius: '50%',
        width: 30,
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '800',
        fontSize: '14px',
        flexShrink: 0,
      }}>
        {count}
      </span>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <span style={{ fontWeight: '700', fontSize: '15px', lineHeight: 1.3 }}>{title}</span>
        {subtitle && (
          <span style={{ fontSize: '12px', color: t.subtitle, fontWeight: '500' }}>{subtitle}</span>
        )}
      </div>

      {cta && (
        <span style={{
          marginLeft: 'auto',
          background: t.accent,
          color: '#fff',
          fontWeight: '700',
          fontSize: '13px',
          padding: '5px 14px',
          borderRadius: '6px',
          flexShrink: 0,
        }}>
          {cta}
        </span>
      )}
    </div>
  );
};

export default ClaimBanner;
